import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface BreadcrumbItem {
  title: string
  disabled?: boolean
  to?: string
}

export const usePageHeaderStore = defineStore('pageHeader', () => {
  const breadcrumbs = ref<BreadcrumbItem[]>([])
  return { breadcrumbs }
})
